module.exports = __webpack_public_path__ + "static/img/p-1010283-copy-2@2x.f1868b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/p-1010283-copy-2@2x.png
// module id = YbBa
// module chunks = 12